import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignCenterSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 3H3v2h10V3zM1 7h14v2H1V7zm2 4h10v2H3v-2z" />
  </svg>
);
export default IconAlignCenterSizeS;
